import clsx from "clsx";
import { ReactNode, useEffect, useRef } from "react";

type DrawerProps = {
  className?: string;
  onClose: () => void;
  children?: ReactNode;
};

export function Drawer({ children, onClose, className }: DrawerProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialogRef.current?.showModal();

    return () => dialogRef.current?.close();
  }, []);

  return (
    <dialog
      className={clsx("drawer", className)}
      ref={dialogRef}
      onClose={onClose}
    >
      {children}
    </dialog>
  );
}
